import cardService from '@/services/card.service'
import { store } from '@/store/store'
import { FilterType } from '@/types/additionalFilters'
import { GenericCardType } from '@/types/card'
import { CardListType, PageCardType } from '@/types/page'
import { filterCardlists } from '@/utils/additionalFilters'

import { SUBMIT_FILTERS } from './types'

export type SubmitFiltersActionType = {
  payload: {
    cardLists: CardListType[]
  }
  type: typeof SUBMIT_FILTERS
}

export const submitFilters = async (filters: FilterType[]) => {
  const dispatch = store.dispatch
  const { initCardLists } = store.getState().cardlists
  const { priceSources } = store.getState().user

  // Get full card data
  const cards = initCardLists.reduce(
    (acc: GenericCardType[], cardList: CardListType) => [...acc, ...cardList.cardviews],
    [],
  )
  const cardNames = cards
    .filter((card: GenericCardType) => !card.is_partner)
    .map((card: GenericCardType) => card.sanitized_wo) as string[]
  const cardMap = await cardService.getCardMap(cardNames)

  // Add page data to cards
  const pageCardList = Object.keys(cardMap).map((key) => {
    const card = cardMap[key]
    const pageCard = cards.find((c) => c.sanitized_wo === card.url)
    return {
      ...card,
      ...pageCard,
    }
  }) as PageCardType[]
  const pageCardMap = pageCardList.reduce(
    (acc, card) => {
      acc[card.sanitized as string] = card
      return acc
    },
    {} as Record<string, PageCardType>,
  )

  // Filter
  const filteredDown = filterCardlists({
    cards: pageCardMap,
    filters,
    initCardLists,
    priceSource: priceSources[0],
  }).filter((section) => section.cardviews.length)

  return dispatch({
    payload: { cardLists: filteredDown },
    type: SUBMIT_FILTERS,
  })
}
